export default __webpack_public_path__ + "static/media/hbs-blk-4.194bfae4.png";